/* eslint-disable no-console */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { CalloutContext, useOkapiKy } from '@folio/stripes/core';
import { FormattedMessage } from 'react-intl';
import TemplateBuilder from '../TemplateBuilder';

function CreateTemplate(props) {
  const history = useHistory();
  const okapiKy = useOkapiKy();
  const context = useContext(CalloutContext);
  const initialValues = {
    templateInfo: {
      name: [
        {
          value: '',
          locale: 'ar',
        },
        {
          locale: 'en-US',
          value: '',
        },
      ],
      description: [
        {
          value: '',
          locale: 'ar',
        },
        {
          value: '',
          locale: 'en-US',
        },
      ],
      code: '',
      isDefault: false,
      isLocked: false,
      active: true,
    },
    templateFields: {
      items: [],
      holdings: [],
      instance: [],
    },
  };

  const onSubmit = (values) => {
    okapiKy
      .post('inventory-templates', {
        timeout: 30000,
        method: 'POST',
        json: {
          ...values.templateInfo,
          templateFields: values.templateFields,
        },
      })
      .json()
      .then((res) => {
        if (res.id) {
          const message = (
            <FormattedMessage
              id="ui-plugin-inventory-templates.createTemplate.callout.created"
              defaultMessage="Template created successfully"
            />
          );
          history.push(`${props.basePath}/${res.id}/view`);
          context.sendCallout({ message });
        }
      })
      .catch(async (err) => {
        console.log(err);
        const res = err.response;
        const text = await res.text();
        console.log(text);
        context.sendCallout({ message: text, type: 'error' });
      });
  };

  return (
    <TemplateBuilder
      initialValues={initialValues}
      onSubmit={onSubmit}
      paneTitle={
        <FormattedMessage
          id="ui-plugin-inventory-templates.createTemplate.pane.paneTitle"
          defaultMessage="Create new inventory template"
        />
      }
    />
  );
}

CreateTemplate.propTypes = {
  basePath: PropTypes.string,
};

export default CreateTemplate;
